import {
	service as serviceIcon,
	genGoogleIcon
} from "@/data/map-markers";
import { TinyColor } from "@ctrl/tinycolor";

export default function getServiceStatusIcon( google, size, color ) {
	const strokeColor = new TinyColor( color )
	.darken( 15 )
	.toString();

	return genGoogleIcon(
		google,
		serviceIcon( color, strokeColor, size )
	);
}
